module.exports = __webpack_public_path__ + "img/hero.d574e00d.png";